/**
 * Route for `multi-client-agency-support`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { MultiClientAgencySupportPage } from "../features/multi-client-agency-support/MultiClientAgencySupportPage";

export const multiClientAgencySupportRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/multi-client-agency-support",
	component: MultiClientAgencySupportPage,
});

export default multiClientAgencySupportRoute;
